import Vue from 'vue'
import * as ModalDialogs from 'vue-modal-dialogs'
import Confirm from './confirm'
require('@/styles/dialog-common.scss')

Vue.use(ModalDialogs)

export const confirm = ModalDialogs.create(Confirm)
